import { render, staticRenderFns } from "./VendorPeroranganBCE.vue?vue&type=template&id=a30a7f62&"
import script from "./VendorPeroranganBCE.vue?vue&type=script&lang=js&"
export * from "./VendorPeroranganBCE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports